
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartProhibitedRestrictedAreas as ObiChartProhibitedRestrictedAreasElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-prohibited-restricted-areas.js';
 
 
 

 
 export const ObiChartProhibitedRestrictedAreas = createComponent({
   react: React,
   tagName: 'obi-chart-prohibited-restricted-areas',
   elementClass: ObiChartProhibitedRestrictedAreasElement,
   events: {
     
   }
  });
 
 